document.addEventListener("DOMContentLoaded", function() {
    const form = document.querySelector('.newsletter-x');
    const emailInput = form.querySelector('[data-input-email]');
    const submitButton = form.querySelector('.btn.focus-inset.has-ltr-icon');
    const errorTooltip = document.createElement('div');
    errorTooltip.classList.add('error-tooltip');
    form.appendChild(errorTooltip);

    const svgIcon = `<svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16px" height="16px" viewBox="0 0 478.125 478.125" xml:space="preserve"><g><g><g><circle cx="239.904" cy="314.721" r="35.878"/><path d="M256.657,127.525h-31.9c-10.557,0-19.125,8.645-19.125,19.125v101.975c0,10.48,8.645,19.125,19.125,19.125h31.9c10.48,0,19.125-8.645,19.125-19.125V146.65C275.782,136.17,267.138,127.525,256.657,127.525z"/><path d="M239.062,0C106.947,0,0,106.947,0,239.062s106.947,239.062,239.062,239.062c132.115,0,239.062-106.947,239.062-239.062S371.178,0,239.062,0z M239.292,409.734c-94.171,0-170.595-76.348-170.595-170.596c0-94.248,76.347-170.595,170.595-170.595s170.595,76.347,170.595,170.595C409.887,333.387,333.464,409.734,239.292,409.734z"/></g></g></g></svg>`;

    function showError(message) {
        errorTooltip.textContent = '';
        errorTooltip.insertAdjacentHTML('beforeend', svgIcon + ` ${message}`);
        errorTooltip.classList.add('visible');
    }

    function hideError() {
        errorTooltip.classList.remove('visible');
    }

    function validateEmail(email) {
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return emailPattern.test(email);
    }

    form.addEventListener('submit', function(event) {
        const emailValue = emailInput.value.trim();

        if (!emailValue) {
            event.preventDefault();
            showError('Email address is required.');
            emailInput.focus();
        } else if (!validateEmail(emailValue)) {
            event.preventDefault();
            showError('Please enter a valid email address.');
            emailInput.focus();
        } else {
            hideError();
        }
    });

    emailInput.addEventListener('input', function() {
        hideError();
    });
});
